import { Button } from 'react-bootstrap';
import { generateFilterSummary } from './generateFilterSummary';
import { defaultFilters } from './defaultFilters';


export default function ReportHeader({ selectedReport, filters, setFilters }) {
    return (
        <div className="d-flex justify-content-between align-items-start flex-wrap">
            <div>
                <h4 className="mb-1">{selectedReport.title}</h4>
                {selectedReport.description && (
                    <small className="text-muted">{selectedReport.description}</small>
                )}
            </div>
            <p className="mt-2 mb-0 text-muted small w-100">
                Filters: {generateFilterSummary(filters)}
            </p>
        </div>
    );
}